import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

import { OrgPartTreeBuilderComponent } from '../org-board/shared/org-part-tree-builder/org-part-tree-builder.component';
import { SearchableSelectComponent } from '../searchable-select/searchable-select.component';

import { OrgCreationWizardComponent } from './org-creation-wizard.component';
import { StepSourceComponent } from './steps/step-1-source.component';
import { StepBasicsComponent } from './steps/step-2-basics.component';
import { StepStructureComponent } from './steps/step-3-structure.component';
import { StepStaffComponent } from './steps/step-4-staff.component';
import { StepFeaturesComponent } from './steps/step-5-features.component';
import { StepReviewComponent } from './steps/step-6-review.component';
import { DraftsPickerDialogComponent } from './dialogs/drafts-picker-dialog.component';
import { OrgSourcePickerDialogComponent } from './dialogs/org-source-picker-dialog.component';
import { PublishAsTemplateDialogComponent } from './dialogs/publish-as-template-dialog.component';

/**
 * Org-creation wizard module — usable from any app that wants the wizard at
 * its own route (newgenus-frontend uses `/organization/new`; admin-tool wires
 * the same).
 *
 * The module declares + exports the wizard shell and its step components.
 * Services are `providedIn: 'root'` (see {@link OrgDraftService},
 * {@link OrgCreationService}) so they survive across app boundaries.
 *
 * Plan reference: §7 — frontend module layout.
 */
@NgModule({
    declarations: [
        OrgCreationWizardComponent,
        StepSourceComponent,
        StepBasicsComponent,
        StepStructureComponent,
        StepStaffComponent,
        StepFeaturesComponent,
        StepReviewComponent,
        DraftsPickerDialogComponent,
        OrgSourcePickerDialogComponent,
        PublishAsTemplateDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        DragDropModule,
        MatButtonModule,
        MatCardModule,
        MatCheckboxModule,
        MatDialogModule,
        MatExpansionModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatMenuModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatTooltipModule,
        // Standalone — gives Step 3 access to the shared org-board builder.
        OrgPartTreeBuilderComponent,
        // Standalone — Step 4 staff table uses the searchable multi-select to
        // assign one person to one or many posts (mirrors the New Hat dialog).
        SearchableSelectComponent,
    ],
    exports: [OrgCreationWizardComponent],
})
export class OrgCreationModule {}
